/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassModuleDisciplineDetailViewModel } from "../types/ClassModuleDisciplineDetailViewModel.ts";
import { classModuleClassViewModelSchema } from "./classModuleClassViewModelSchema.ts";
import { classModuleRecurrenceViewModelSchema } from "./classModuleRecurrenceViewModelSchema.ts";
import { eClassTypeSchema } from "./eClassTypeSchema.ts";

export const classModuleDisciplineDetailViewModelSchema = z.object({
  disciplineId: z.optional(z.number().int()),
  disciplineName: z.string().nullish(),
  quantity: z.optional(z.number().int()),
  classroomId: z.number().int().nullish(),
  classroomName: z.string().nullish(),
  teacherPersonId: z.number().int().nullish(),
  teacherName: z.string().nullish(),
  showOnStudentDocument: z.optional(z.boolean()),
  isIncludedInGradeCalculation: z.optional(z.boolean()),
  isIncludedInAttendanceCalculation: z.optional(z.boolean()),
  type: z.optional(
    z.lazy(() => eClassTypeSchema).describe("1 = Normal | 2 = OnDemand | "),
  ),
  planningWithExam: z.optional(z.boolean()),
  useMoveQA: z.optional(z.boolean()),
  isVisualizationAttendance: z.optional(z.boolean()),
  recurrences: z
    .array(z.lazy(() => classModuleRecurrenceViewModelSchema))
    .nullish(),
  classes: z.array(z.lazy(() => classModuleClassViewModelSchema)).nullish(),
}) as unknown as ToZod<ClassModuleDisciplineDetailViewModel>;
